import Ajax from '../ajax'

export default {
  contactUs: (data) => Ajax('post', 'offcialsite/contact', data)
}
